<template>
    <div class="row">
        <FormGroup :label="$t('labels.user_name')" class="col-lg-6">
            <Input v-model="login"/>
        </FormGroup>
        <FormGroup :label="$t('labels.api_token')" class="col-lg-6">
            <Input v-model="token"/>
        </FormGroup>
    </div>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';

export default {
    name: "IntelTeleCredentialFields",
    components: {
        FormGroup, Input
    },
    props: {
        credential: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            login: this.credential?.login ?? '',
            token: this.credential?.token ?? ''
        };
    },
    methods: {
        buildRequest() {
            let request = {
                login: this.login,
                token: this.token
            };

            return request;
        }
    }
}
</script>
